import { Vue, Component, Prop } from 'vue-property-decorator'
import { notificationNamespace } from '@/store/notifications.store'
import { Notification } from '@/model/notification'
import moment from 'moment'

@Component
export default class NotificationComponentMixin extends Vue {
  @Prop()
  notification!: Notification

  @notificationNamespace.Mutation('deleteNotification')
  mutationDeleteNotification!: (notificationId: String) => void

  @notificationNamespace.Action('deleteNotification')
  actionDeleteNotification!: (notificationId: String) => Promise<void>

  deleting: boolean = false

  get notificationDeliveryDelay () {
    const diff = moment.duration(moment().diff(moment(this.notification.timeCreated)))
    const days = diff.asDays()
    if (days > 1) {
      return Math.round(days) + ' days'
    }

    const hours = diff.asHours()
    if (hours > 1) {
      return Math.round(hours) + ' hours'
    }

    const minutes = diff.asMinutes()
    if (minutes > 1) {
      return Math.round(minutes) + ' minutes'
    }

    const seconds = diff.asSeconds()
    if (seconds > 1) {
      return Math.round(seconds) + ' seconds'
    }
  }

  async deleteNotification () {
    this.deleting = true
    await this.actionDeleteNotification(this.notification.id)
    this.deleting = false
  }
}
